import React from 'react'


export default function ourServices(props) {
  return (
    <>
    <div className="py-1 servicesSmallTitle ">
      <h2 className="title1">{props.title1} </h2>
      <h2 className="title2"> {props.title2}</h2>
    </div>
    <p className="py-2 mb-3">
      {props.text}
    </p>
    <h4 className="pushLinkDown">
      <a href="/services">READ MORE</a>
    </h4>
    </>
  )
}